import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  withArrow?: boolean;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#1A1A1A] text-white hover:bg-[#0F0F0F] shadow-[0_2px_10px_rgba(0,0,0,0.06)] border border-transparent',
    secondary: 'bg-white text-[#1A1A1A] border border-[#E8E6E3] hover:border-[#D0CEC9] hover:bg-[#FAF9F7] shadow-sm',
    ghost: 'bg-transparent text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30'
  };
  const sizes = 'px-6 py-3 text-base';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes} ${className}`} {...props} data-id="element-119">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-4 w-4" data-id="element-120" />}
    </button>;
}